const environment = {
    // apiUrl: 'https://localhost:44325/api/',  // local
    // apiCarparkUrl: 'https://localhost:44325/api/',  // Carpark local

    apiUrl: 'https://fineday-api.objective-faraday.119-59-118-127.plesk.page/api/',  // VPS
    apiCarparkUrl: 'https://fineday-api.objective-faraday.119-59-118-127.plesk.page/api/',  // Carpark VPS

    // apiCarparkUrl: 'https://smartgate-carpark-api.chememan.com/api/',  // OB prod Server
    // apiUrl: 'https://smartgate-core-api.chememan.com/api/',  // OB Carpark prod Server/
    apiReport: 'https://smartgate-report.chememan.com/',
}
export default environment